import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

// Se conecta a un input de texto y lo convierte en un selector de fecha.
// Al cambiar la fecha, envía una petición PATCH para actualizar el ticket.
export default class extends Controller {
  static values = {
    url: String, // La URL para actualizar el ticket
  }

  connect() {
    this.fp = flatpickr(this.element, {
      dateFormat: "Y-m-d", // Formato para el servidor
      altInput: true,      // Muestra un input amigable separado
      altFormat: "M j, Y", // Formato para el usuario
      onChange: this.updateDate.bind(this), // Llama a nuestra función al cambiar
    });
  }

  disconnect() {
    this.fp.destroy();
  }

  // Envía la fecha seleccionada al servidor
  async updateDate(selectedDates, dateStr, instance) {
    const url = this.urlValue;
    const newDate = dateStr;

    // Obtiene el token CSRF para la autenticación de Rails
    const csrfToken = document.querySelector("meta[name='csrf-token']").content;

    try {
      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({
          ticket: {
            fecha_programada: newDate
          }
        })
      });

      if (!response.ok) {
        throw new Error('Error al actualizar la fecha.');
      }

      // Turbo se encargará de actualizar la vista si el controlador responde
      // con un turbo_stream. No necesitamos hacer nada más aquí.

    } catch (error) {
      console.error("Hubo un error:", error);
      alert("No se pudo actualizar la fecha. Por favor, inténtalo de nuevo.");
    }
  }
}